<base-infopage [staticMapInput]="staticMapInput()">
    @if(keyInfoIsLoading()){
    <div class="loader">
        <ev-logo-loader width="70px" />
    </div>

    } @else if (keyInfoError()){
    <div>{{ keyInfoError() }}</div>
    }@else{
    <infopage-address-header
        [keyInfo]="keyInfo()"
        [organization]="organization()"
        [identityText]="keyInfo()?.externalKey"
        [navigationType]="NavigationType.StockCooperativeShare"
        [navigationMenuItems]="menuItems()"
    ></infopage-address-header>
    <key-info
        [keyInfoData]="keyInfo()"
        [imagePackages]="imagePackages()"
        [specialConstraints]="specialConstraints()"
        [physicalExposures]="physicalExposures()"
        (expandDetailsClicked)="goToAccordion($event)"
        [foreclosureDiscount]="foreclosureDiscount()"
        [navigationMenuItems]="menuItems()"
    ></key-info>
    <div class="accordions">
        <infopage-accordion [accordionState]="valueHistoryAccordionStateClass">
            <div class="accordion-toolbar">
                <valuation-history-filter [(selectedFilters)]="selectedFilters" [isCommercial]="false"></valuation-history-filter>
            </div>

            <valuation-history-residential
                [valuationHistory]="valueHistoryAccordionStateClass.data()"
                [selectedFilters]="selectedFilters()"
            ></valuation-history-residential>
        </infopage-accordion>
        <infopage-accordion [accordionState]="energyAccordionStateClass">
            <unit-energy-info [energyInfo]="energyAccordionStateClass.data()" [keyInfo]="keyInfo()"></unit-energy-info>
        </infopage-accordion>
        <infopage-accordion [accordionState]="keyInfoAccordionStateClass">
            <key-info-details [keyInfoData]="keyInfo()" [neighbourhoodData]="neighbourhoodData()"></key-info-details>
        </infopage-accordion>
        <infopage-accordion [accordionState]="publicAddressInfoAccordionStateClass">
            <public-address-info [addressInfo]="publicAddressInfoAccordionStateClass.data()"></public-address-info>
        </infopage-accordion>
        <infopage-accordion [accordionState]="buildingAccordionStateClass">
            <buildings [propertyInformation]="buildingAccordionStateClass.data()"></buildings>
        </infopage-accordion>
        <infopage-accordion [accordionState]="physicalRiskAccordionStateClass">
            <physical-exposures [data]="physicalRiskAccordionStateClass.data()"></physical-exposures>
        </infopage-accordion>
        <infopage-accordion [accordionState]="specialConstraintsAccordionStateClass" (toggled)="specialConstraintsAccordionStateClass.expanderClicked()">
            <special-constraints
                [data]="specialConstraintsAccordionStateClass.data()?.aggregatedSpecialConstraints"
                [hideLandRegUrl]="false"
                [registeredType]="specialConstraintsAccordionStateClass.data()?.registeredType"
                [reportUrls]="reportUrls()"
            ></special-constraints>
        </infopage-accordion>
        <infopage-accordion [accordionState]="businessManagerAccordionStateClass">
            <business-manager [data]="businessManagerAccordionStateClass.data()"></business-manager>
        </infopage-accordion>
        <infopage-accordion [accordionState]="nearbySalesAccordionStateClass">
            <nearby-sales [nearbySales]="nearbySalesAccordionStateClass.data()"></nearby-sales>
        </infopage-accordion>
        <infopage-accordion [accordionState]="nearbySiteSalesAccordionStateClass">
            <nearby-site-sales [nearbySiteSales]="nearbySiteSalesAccordionStateClass.data()"></nearby-site-sales>
        </infopage-accordion>
    </div>
}
</base-infopage>
